<template>
  <div class="banner" :class="cssType">
    <div class="logo" :class="locale"></div>
    <div class="main-title" :class="locale"></div>
    <div class="bottom-line"></div>
    <div class="end-countdown" :class="locale">
      <span>
        {{ $t('sf.endCountdown') }}
      </span>
      <span>
        {{ endCountdown.day }}
        {{ $t('sf.day') }}
        {{ endCountdown.hour }}
        :
        {{ endCountdown.minute }}
        :
        {{ endCountdown.second }}
      </span>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { inject, computed, reactive, watch, onMounted, onBeforeUnmount } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
const globalConfig = inject('globalConfig')
const cssType = isMobile ? 'mobile' : 'pc'

const state = reactive({
  seconds: 0,
  timer: null,
  serverToLocalDiff: 0, // 服务器时间与本地时间的差值（秒）
  isInitialized: false, // 是否已初始化
})

// 初始化服务器时间差值和开始倒计时
const initCountdown = () => {
  if (state.isInitialized) {
    return // 避免重复初始化
  }
  
  if (globalConfig?.commonConfig?.serverTime) {
    console.log('globalConfig.commonConfig.serverTime found', globalConfig.commonConfig.serverTime)
    const serverTime = globalConfig.commonConfig.serverTime
    // 确保是秒时间戳
    const serverTimeSeconds = serverTime > 10000000000 ? Math.floor(serverTime / 1000) : serverTime
    state.serverToLocalDiff = serverTimeSeconds - Math.floor(Date.now() / 1000)
    state.isInitialized = true
    
    // 开始倒计时
    if (!state.timer) {
      countDown()
    }
  } else {
    console.log('globalConfig.commonConfig.serverTime not found')
  }
}

// 监听 globalConfig.commonConfig 的变化
watch(
  () => globalConfig?.commonConfig,
  (newVal) => {
    console.log('globalConfig.commonConfig changed', newVal, newVal.serverTime)
    if (newVal && newVal.serverTime && !state.isInitialized) {
      initCountdown()
    }
  },
  { immediate: true, deep: true }
)

// 也监听 serverTime 的变化（如果后续会更新）
watch(
  () => globalConfig?.commonConfig?.serverTime,
  (newVal) => {
    if (newVal && !state.isInitialized) {
      initCountdown()
    }
  },
  { immediate: true }
)

const countDown = () => {
  if (state.timer) {
    return // 避免重复创建定时器
  }
  state.timer = setInterval(() => {
    state.seconds++
  }, 1000)
}

onBeforeUnmount(() => {
  if (state.timer) {
    clearInterval(state.timer)
    state.timer = null
  }
})

const endCountdown = computed(() => {
  const res = {
    day: '00',
    hour: '00',
    minute: '00',
    second: '00',
  }
  
  if (!globalConfig?.commonConfig?.activityEndTime || !globalConfig?.commonConfig?.serverTime || !state.isInitialized) {
    return res
  }
  
  const activityEndTime = globalConfig.commonConfig.activityEndTime
  // 确保是秒时间戳
  const endTimeSeconds = activityEndTime > 10000000000 ? Math.floor(activityEndTime / 1000) : activityEndTime
  
  // 计算当前服务器时间（秒）= 初始服务器时间 + 已过秒数
  // 使用 state.seconds 来触发响应式更新
  const currentServerTime = (globalConfig.commonConfig.serverTime > 10000000000 
    ? Math.floor(globalConfig.commonConfig.serverTime / 1000) 
    : globalConfig.commonConfig.serverTime) + state.seconds
  
  // 计算时间差（秒）
  const diff = Math.max(0, endTimeSeconds - currentServerTime)
  
  // 转换为天、时、分、秒
  const day = Math.floor(diff / 86400)
  const hour = Math.floor((diff % 86400) / 3600)
  const minute = Math.floor((diff % 3600) / 60)
  const second = diff % 60

  res.day = day;
  res.hour = hour >= 10 ? hour : '0' + hour;
  res.minute = minute >= 10 ? minute : '0' + minute;
  res.second = second >= 10 ? second : '0' + second;
  
  return res
})
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>